import EmploymentApplication from './components/EmploymentApplication';
import './App.css';

function App() {
    return <EmploymentApplication />;
}

export default App;
